<template>
  <NavBar v-if="!isMobile()" ></NavBar>
  <NavBarmob v-if="isMobile()"></NavBarmob>
  <UserBanner :name="customer.name"></UserBanner>
  <main>
    <section class="content-section padprof"  >
    <div class="container">
      <div class="row ">
        <UserDetails :name="customer.name" :email="customer.email" :mobile="customer.mobile" :logincode="customer.loginCode"></UserDetails>
        <EditProfile :name="customer.name" :email="customer.email" :mobile="customer.mobile" :logincode="customer.loginCode"></EditProfile>
      </div>
      </div>
      </section>
      <SiteFooter v-if="!isMobile()"></SiteFooter>
      <Footermob v-if="isMobile()"></Footermob>

  </main>
</template>

<script>
import NavBar from '../UI/NavBar.vue';
import UserBanner from './UserBanner.vue';
import UserDetails from './UserDetails.vue';
import EditProfile from './EditProfile.vue';
import SiteFooter from '../UI/SiteFooter.vue';
import NavBarmob from "../UI/NavBarmob.vue";
import Footermob from "../Indexmobile/IndexFooter.vue";
import axios from 'axios';
import { URL } from '@/conf';
export default {
  data:()=>({
    customer:{
            loginCode:localStorage.getItem("loginCode"),
            mobile:null,
            email:null,
            name:null,},
  }),
components:{
    NavBar,
    UserBanner,
    UserDetails,
    EditProfile,
    SiteFooter,
    NavBarmob,
    Footermob
},
methods:{
  getUser(){
      axios
        .get(URL + "checkLogin?code="+localStorage.getItem("loginCode"))
        .then((response) => {
          if(response.data.status=="done"){
            this.customer=response.data;
          }
        })
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
},
mounted:async function(){
  this.getUser();
    var mastHeight=document.querySelector('.page-header, .slider').clientHeight;
    document.querySelector('main').style.marginTop=mastHeight+"px";
  }
}
</script>
<style></style>
